// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root, .App{
  width: 100%;
  overflow-x: hidden; /* Esconde qualquer rolagem horizontal */
  overflow-y: auto; /* Permite rolagem vertical */
  box-sizing: border-box;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB,EAAE,wCAAwC;EAC5D,gBAAgB,EAAE,6BAA6B;EAC/C,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ","sourcesContent":["html, body, #root, .App{\n  width: 100%;\n  overflow-x: hidden; /* Esconde qualquer rolagem horizontal */\n  overflow-y: auto; /* Permite rolagem vertical */\n  box-sizing: border-box;\n  overflow-x: hidden;\n  margin: 0;\n  padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
